<template>
    <el-drawer
        :title="type === 0 ? $i18n.t('ota.text9') : $i18n.t('ota.text105')"
        :visible.sync="drawer"
        :size="500"
        direction="rtl"
        append-to-body
        :wrapperClosable="false"
        @open="handleOpen"
        @close="closeDialog">
        <div class="title">{{$i18n.t('ota.text41')}}</div>
        <el-form
            :model="form" size="small"
            :rules="rules"
            ref="ruleForm"
            label-position="top"
            class="ota_form">

            <el-form-item prop="pid">
                <span slot="label">
                    {{$i18n.t('ota.text42')}}
                    <el-popover
                        placement="bottom"
                        title=""
                        width="200"
                        trigger="hover">
                        <div>
                            <p>{{$i18n.t('ota.text43')}}</p>
                            <p>{{$i18n.t('ota.text44')}}</p>
                        </div>
                        <i
                            :class="productIcon"
                            @mouseover="productIcon = 'empower_question_coicon icon-yuanyin'"
                            @mouseleave="productIcon = 'empower_question_alicon iconfont_al icon-yiwen'"
                            slot="reference"></i>
                    </el-popover>
                </span>
                <el-select
                    style="width: 100%;"
                    :remote-method="remoteMethod"
                    @change="selectPid"
                    allow-create
                    :loading="loadingProduct"
                    v-model="form.pid"
                    remote
                    ref="selectProduct"
                    filterable
                    :disabled="type === 1"
                    :placeholder="$i18n.t('ota.text45')">
                    <el-option-group
                        v-for="group in productList"
                        :key="group.label"
                        :label="group.label">
                        <el-option
                            v-for="item in group.options"
                            :key="item.value"
                            :label="item.label + `(PID：${item.value})`"
                            :value="item.value">
                        </el-option>
                    </el-option-group>
                </el-select>
            </el-form-item>


            <el-form-item prop="firmwareModel">
                <span slot="label">
                    {{$i18n.t('ota.text46')}}
                    <el-popover
                        placement="bottom"
                        title=""
                        width="200"
                        trigger="hover">
                        <div>
                            {{$i18n.t('ota.text47')}}
                        </div>
                        <i
                            :class="firmwareIcon"
                            @mouseover="firmwareIcon = 'empower_question_coicon icon-yuanyin'"
                            @mouseleave="firmwareIcon = 'empower_question_alicon iconfont_al icon-yiwen'"
                            slot="reference"></i>
                    </el-popover>
                </span>
                <el-input :disabled="type === 1" style="width: 100%;" v-model="form.firmwareModel" :placeholder="$i18n.t('ota.text48')"/>
            </el-form-item>


            <el-form-item :label="$i18n.t('releaseMsg.text71')" prop="versionType">
              <el-radio-group v-model="form.versionType">
                <el-radio :label="0">{{$i18n.t('releaseMsg.text69')}}</el-radio>
                <el-radio :label="1">{{$i18n.t('releaseMsg.text70')}}</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item class="is-required file-upload" :error="firmwareErr">
                <span slot="label">
                    {{$i18n.t('ota.text53')}}
                    <el-popover
                        placement="bottom"
                        title=""
                        width="200"
                        trigger="hover">
                        <div>
                            {{$i18n.t('ota.text54')}}
                        </div>
                        <i
                            :class="uploadIcon"
                            @mouseover="uploadIcon = 'empower_question_coicon icon-yuanyin'"
                            @mouseleave="uploadIcon = 'empower_question_alicon iconfont_al icon-yiwen'"
                            slot="reference"></i>
                    </el-popover>
                </span>

                <div class="upload-body"
                     :style="{cursor: type === 0 ? (file.name ? 'context-menu' : 'pointer') : 'not-allowed', opacity: type === 0 ? '1' : '.8'}"
                     :loading="fileLoading">
                    <el-upload
                        class="upload-demo"
                        ref="upload"
                        action=""
                        :auto-upload="false"
                        :disabled="type === 1 || !!file.name"
                        drag
                        :http-request="customUpload"
                        :before-upload="beforeUpload"
                        :on-change="handleFileChange"
                        :limit="1"
                        :show-file-list="false"
                        accept=".zip">
                        <div v-if="!file.name" >
                            <i class="el-icon-upload" style="margin-top: 40px;font-size: 40px;"></i>
                            <div class="el-upload__text">{{$i18n.t('empower.text65')}}</div>
                            <div class="el-upload__subtitle">{{$i18n.t('ota.text49')}}</div>
                        </div>
                        <div v-else-if="isShowProgress" style="margin-top: 35px;">
                            <el-progress type="circle" :percentage="progress" :status="progressStatus"></el-progress>
                        </div>
                        <div class="upload-msg"
                             :style="{cursor: type === 0 ? (file.name ? 'context-menu' : 'pointer') : 'not-allowed', opacity: type === 0 ? '1' : '.8'}" v-else>
                            <div style="width: 100%;word-wrap: break-word;">
                                {{ file.name }}
                                <el-button type="text" style="padding: 0px;"
                                           icon="el-icon-delete" @click.stop="delBtn()"></el-button>
                            </div>
                        </div>
                    </el-upload>
                    <div class="upload_title">
                        {{$i18n.t('ota.text50')}}
                        <a style="color: rgb(24, 144, 255)" href="https://oss.funlink.cloud/common/hbxpfca/res/20240928/dz7rpgjfzeo0/ota_pack_2_1_21_33.zip">{{$i18n.t('ota.text51')}}</a>
<!--                        <el-button type="text"-->
<!--                                 style="font-size: 12px;margin-left: 10px;">升级包示例-->
<!--                        </el-button>-->
                    </div>
                </div>
            </el-form-item>

            <div class="title" style="margin-top: 106px;margin-bottom: 17px;">{{$i18n.t('ota.text52')}}</div>
            <el-form-item prop="triggerType">
                <span slot="label">
                    {{$i18n.t('ota.text55')}}
                    <el-popover
                        placement="bottom"
                        title=""
                        width="200"
                        trigger="hover">
                        <div>
                            {{$i18n.t('ota.text56')}}<br>
                            {{$i18n.t('ota.text57')}}<br>
                            {{$i18n.t('ota.text58')}}<br>
                            {{$i18n.t('ota.text59')}}<br>
                        </div>
                        <i
                            :class="triggerModeIcon"
                            @mouseover="triggerModeIcon = 'empower_question_coicon icon-yuanyin'"
                            @mouseleave="triggerModeIcon = 'empower_question_alicon iconfont_al icon-yiwen'"
                            slot="reference"></i>
                    </el-popover>
                </span>
                <el-select style="width: 100%;" v-model="form.triggerType" @change="triggerChange" :disabled="form.pid === ''" :placeholder="$i18n.t('ota.text60')">
                    <el-option
                        v-for="item in triggerModeList"
                        :disabled="item.isDisabled"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item prop="downloadType">
                <span slot="label">
                    {{$i18n.t('ota.text63')}}
                    <el-popover
                        placement="bottom"
                        title=""
                        width="260"
                        trigger="hover">
                        <div>
                            {{$i18n.t('ota.text64')}}<br>
                            {{$i18n.t('ota.text65')}}<br>
                        </div>
                        <i
                            :class="downloadTypeIcon"
                            @mouseover="downloadTypeIcon = 'empower_question_coicon icon-yuanyin'"
                            @mouseleave="downloadTypeIcon = 'empower_question_alicon iconfont_al icon-yiwen'"
                            slot="reference"></i>
                    </el-popover>
                </span>
                <el-select style="width: 100%;" v-model="form.downloadType" @change="downloadChange" :disabled="form.triggerType ===''" :placeholder="$i18n.t('ota.text61')">
                    <el-option
                        v-for="item in downloadTypeList"
                        :disabled="item.isDisabled"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item prop="installType">
                <span slot="label">
                    {{$i18n.t('ota.text66')}}
                    <el-popover
                        placement="bottom"
                        title=""
                        width="260"
                        trigger="hover">
                        <div>
                            {{$i18n.t('ota.text67')}}<br>
                            {{$i18n.t('ota.text68')}}<br>
                        </div>
                        <i
                            :class="installTypeIcon"
                            @mouseover="installTypeIcon = 'empower_question_coicon icon-yuanyin'"
                            @mouseleave="installTypeIcon = 'empower_question_alicon iconfont_al icon-yiwen'"
                            slot="reference"></i>
                    </el-popover>
                </span>
                <el-select style="width: 100%;" v-model="form.installType" :disabled="form.downloadType === ''" :placeholder="$i18n.t('ota.text62')">
                    <el-option
                        v-for="item in installTypeList"
                        :disabled="item.isDisabled"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>


            <el-form-item :label="$i18n.t('ota.text69')" prop="reboot">
                <el-radio-group v-model="form.reboot">
                    <el-radio :label="item.value" :key="index" v-for="(item, index) in rebootList">
                        {{ item.label }}
                    </el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item :label="$i18n.t('ota.text70')">
                <el-checkbox-group v-model="partitions">
                    <el-checkbox :label="item.value" :key="index" v-for="(item, index) in partitionList">{{item.label}}</el-checkbox>
                </el-checkbox-group>
                <el-button type="text" @click="addPartition">{{$i18n.t('ota.text71')}}</el-button>
            </el-form-item>

            <el-form-item :label="$i18n.t('ota.text72')" prop="versionDescribe">
                <el-input
                    type="textarea"
                    :rows="4"
                    :maxlength="200"
                    :placeholder="$i18n.t('ota.text73')"
                    v-model="form.versionDescribe">
                </el-input>
                <div style="position: absolute;right: 0">{{form.versionDescribe.length}}/200</div>
            </el-form-item>

        </el-form>

        <!-- 弹窗底部按钮 start -->
        <div class="demo-drawer__footer">
            <el-button @click="closeDialog">{{$i18n.t('ota.text35')}}</el-button>
            <el-button type="primary" @click="submit" :loading="loading">{{type === 0 ? $i18n.t('ota.text74') : $i18n.t('ota.text75')}}</el-button>
        </div>
        <!-- 弹窗底部按钮 end -->
    </el-drawer>
</template>

<script>
import {mapActions, mapState} from "vuex";
import axios from "axios";
import SparkMD5 from "spark-md5";

export default {
    name: "addOTADrawer",

    computed: {
        ...mapState('maintain', ['addOTADrawerVisible', 'addOTADrawerType', 'firmwareMsg'])
    },

    watch: {

        addOTADrawerVisible: {
            handler(newVal) {
                this.drawer = newVal;
            },
            deep: true
        },

        addOTADrawerType: {
            handler(newVal) {
                console.log('addOTADrawerType', newVal)
                this.type = newVal;
            },
            deep: true
        },

        firmwareMsg: {
            async handler(newVal) {
                console.log(newVal)

                if (newVal.productType === 1) {
                    await this.getProduct();
                } else {
                    this.productList = [{
                        label: this.$i18n.t('ota.text77'),
                        options: [
                            {
                                label: newVal.productName,
                                value: newVal.pid
                            }
                        ]
                    }]
                }
                this.form = {
                    otaFileCode: newVal.otaFileCode,
                    firmwareModel: newVal.firmwareModel,
                    filePath: newVal.srcFilePath,
                    fileUrl: newVal.srcFileUrl,
                    productType: newVal.productType,
                    triggerType: (newVal.triggerType || newVal.triggerType === 0) ? newVal.triggerType : '',
                    downloadType: (newVal.downloadType || newVal.downloadType === 0) ? newVal.downloadType : '',
                    installType: (newVal.installType || newVal.installType === 0) ? newVal.installType : '',
                    reboot: newVal.reboot ? "1" : "2",
                    versionDescribe: newVal.versionDescribe ? newVal.versionDescribe : '',
                    pid: newVal.pid,
                    versionType: newVal.versionType + '' ? newVal.versionType : 1,
                }
                console.log(this.productList)
                let partitions = [];
                if (newVal.wipeData) partitions.push(1)
                if (newVal.wipeMedia) partitions.push(2)
                newVal.wipeArea && newVal.wipeArea !== "" && JSON.parse(newVal.wipeArea).forEach(item => {
                    this.partitionList.push({label: item.n, value: item.k})
                    if (item.v) partitions.push(item.k)
                })
                this.partitions = partitions;
                if (!newVal.srcFilePath) return
                let filePathList = newVal.srcFilePath.split("/")
                this.file.name = filePathList[filePathList.length - 1];
            }
        }
    },

    data() {
        return {
            type: 0,
            drawer: false,
            loading: false,
            productIcon: "empower_question_alicon iconfont_al icon-yiwen",
            firmwareIcon: "empower_question_alicon iconfont_al icon-yiwen",
            uploadIcon: "empower_question_alicon iconfont_al icon-yiwen",
            triggerModeIcon: "empower_question_alicon iconfont_al icon-yiwen",
            downloadTypeIcon: "empower_question_alicon iconfont_al icon-yiwen",
            installTypeIcon: "empower_question_alicon iconfont_al icon-yiwen",
            fileLoading: false,
            loadingProduct: false,
            productName: '',
            language: localStorage.getItem('language'),
            form: {
                otaFileCode: '',
                pid: "",
                firmwareModel: "",
                filePath: "",
                fileUrl: "",
                productType: 1,
                triggerType: "",
                downloadType: "",
                installType: "",
                reboot: "1",
                versionDescribe: "",
                versionType: 1
            },
            partitions: [],
            file: {},
            chunkSize: 8 * 1024 * 1024, // 每个分片大小（8MB）
            uploadedChunks: 0, // 已上传的分片数
            totalChunks: 0, // 总分片数
            fileSize: 0, // 文件大小
            md5: null, // 文件MD5值
            progress: 0, // 上传进度
            progressStatus: null,
            uploadedChunksList: [], // 已上传的分片列表（用于断点续传）
            uploadId: null, // 上传会话ID
            isShowProgress: false,
            isUpload: true,
            firmwareErr: "",
            rules: {
                pid: {required: true, message: this.$i18n.t('ota.text45'), trigger: 'change'},
                firmwareModel: {required: true, message: this.$i18n.t('ota.text78'), trigger: 'change'},
                triggerType: {required: true, message: this.$i18n.t('ota.text60'), trigger: 'change'},
                downloadType: {required: true, message: this.$i18n.t('ota.text61'), trigger: 'change'},
                installType: {required: true, message: this.$i18n.t('ota.text62'), trigger: 'change'},
                reboot: {required: true, message: this.$i18n.t('ota.text79'), trigger: 'change'},
                versionDescribe: {required: true, message: this.$i18n.t('ota.text73')},
                versionType: {required: true, message: this.$i18n.t('releaseMsg.text72'), trigger: 'change'}
            },
            installTypeList: this.$message.installTypeList,
            triggerModeList: this.$message.triggerModeList,
            productList: [
                {
                    label: this.$i18n.t('ota.text76'),
                    options: []
                },
                {
                    label: this.$i18n.t('ota.text77'),
                    options: []
                }
            ],
            downloadTypeList: [
                {label: this.$i18n.t('ota.text80'), value: 0, isDisabled: false},
                {label: this.$i18n.t('ota.text81'), value: 1, isDisabled: false},
            ],
            rebootList: [
                {label: this.$i18n.t('ota.text82'), value: '1'},
                {label: this.$i18n.t('ota.text83'), value: '2'},
            ],
            partitionList: [
                {label: this.$i18n.t('ota.text84'), value: 1},
                {label: this.$i18n.t('ota.text85'), value: 2},
            ],
            searchProductTimeout: null
        }
    },

    methods: {

        ...mapActions('product', ['queryProduct']),
        ...mapActions('maintain', ['closeAddOTADrawer', 'queryProductAndAliasSimpleList', 'addProductalias', 'importFirmwareFile', 'modifyFirmwareFile']),

        selectPid(event) {
            console.log(event)
            if (this.productName === event) {
                this.$dialog.showConfirm({
                    content: this.$i18n.t('ota.text86'),
                    title: this.$i18n.t('ota.text87'),
                    btn1: this.$i18n.t('ota.text82'),
                    btn2: this.$i18n.t('ota.text83'),
                    icon: 2
                }, () => {
                    this.addProductalias({
                        name: event
                    }).then(res => {
                        if (this.productList[1].options) {
                            this.productList[1].options.push({
                                label: event,
                                value: res.result
                            })
                        } else {
                            this.productList[1] ={
                                label: this.$i18n.t('ota.text77'),
                                options: [{
                                    label: event,
                                    value: res.result
                                }]
                            }
                        }
                        this.form.pid = res.result;
                        this.form.productType = 2;
                        this.triggerModeList.forEach(item => {
                            item.isDisabled = !(item.value === 0 || item.value === 3);
                        })
                        this.form.triggerType = "";
                        this.form.downloadType = "";
                        this.form.installType = "";
                        this.$refs.selectProduct.blur();

                    })
                }, () => {
                    this.form.pid = ""
                    this.$refs.selectProduct.blur();
                })
            } else {
                this.form.pid = event;
                let isIOTProduct = false;
                this.productList[0].options.forEach(item => {
                    if (item.value === event) {
                        isIOTProduct = true;
                    }
                });
                this.form.productType = isIOTProduct ? 1 : 2;
                this.form.productType === 1 && this.triggerModeList.forEach(item => {item.isDisabled = false;})
                this.form.productType === 2 && this.triggerModeList.forEach(item => {
                    item.isDisabled = !(item.value === 0 || item.value === 3);
                })
                this.form.triggerType = "";
                this.form.downloadType = "";
                this.form.installType = "";
            }
        },

        getProduct() {
          console.log(this.firmwareMsg)
            this.loadingProduct = true;
            this.productList = []
            this.queryProduct({"currPage":1,"pageSize":10,"keyword":this.firmwareMsg.productName,"productStatus":3,"protocolType":""}).then(res => {
                let productList = [];
                res.result.list.forEach(item => {
                    productList.push({
                        label: item.name,
                        value: item.pid
                    })
                })

                this.productList[0] = productList.length > 0 ? {
                    label: this.$i18n.t('ota.text76'),
                    options: productList
                } : {}
                this.productList[1] = {}
            }).finally(() => this.loadingProduct = false)
        },

        remoteMethod(event) {
            this.productName = event;
            this.loadingProduct = true;
            if (this.searchProductTimeout) clearTimeout(this.searchProductTimeout);
            this.searchProductTimeout = setTimeout(() => {
                if (event === '') {
                    this.getProduct();
                    return;
                }
                this.queryProductAndAliasSimpleList({
                    productName: event
                }).then(res => {
                    if (res.code === '0') {
                        let productAliasList = [];
                        let productList = [];
                        res.result.productAliasList.forEach(item => {
                            productAliasList.push({
                                label: item.name,
                                value: item.pid
                            })
                        })
                        res.result.productList.forEach(item => {
                            productList.push({
                                label: item.name,
                                value: item.pid
                            })
                        })
                        this.productList[0] = productList.length > 0 ? {
                            label: this.$i18n.t('ota.text76'),
                            options: productList
                        } : {}
                        this.productList[1] = productAliasList.length > 0 ? {
                            label: this.$i18n.t('ota.text77'),
                            options: productAliasList
                        } : {}
                    }
                }).finally(() => this.loadingProduct = false)
            }, 1000)
        },

        addPartition() {
            this.$prompt(this.$i18n.t('ota.text88'), this.$i18n.t('ota.text71'), {
                confirmButtonText: this.$i18n.t('ota.text89'),
                cancelButtonText: this.$i18n.t('ota.text35'),
                inputPattern: /^(?!\s*$).{1,20}$/,
                inputErrorMessage: this.$i18n.t('ota.text90')
            }).then(({ value }) => {
                this.partitionList.push({
                    value: this.partitionList.length + 1,
                    label: value
                })
                this.$message({
                    type: 'success',
                    message: this.$i18n.t('ota.text91')
                });
            }).catch(() => {});
        },

        delBtn() {
            this.file = {}
            this.form.filePath = '';
            this.form.fileUrl = '';
            this.progress = 0;
            this.uploadedChunksList = [];
            this.$refs.upload.clearFiles();
        },

        triggerChange(event) {
            this.form.downloadType = "";
            this.form.installType = "";
            // 产品
            (this.form.productType === 1 && event === 0) && this.downloadTypeList.forEach(item => {item.isDisabled = false;});
            (this.form.productType === 1 && event === 1) && this.downloadTypeList.forEach(item => {
                item.isDisabled = false;
            });
            (this.form.productType === 1 && event === 2) && this.downloadTypeList.forEach(item => {
                item.isDisabled = item.value !== 0;
            });
            (this.form.productType === 1 && event === 3) && this.downloadTypeList.forEach(item => {
                item.isDisabled = item.value !== 0;
            });

            // 昵称
            (this.form.productType === 2 && event === 0) && this.downloadTypeList.forEach(item => {item.isDisabled = false;});
            (this.form.productType === 2 && event === 3) && this.downloadTypeList.forEach(item => {
                item.isDisabled = item.value !== 0;
            });
        },

        downloadChange(event) {
            this.form.installType = "";
            //产品
            (this.form.productType === 1 && this.form.triggerType === 0 && event === 0) && this.installTypeList.forEach(item => {item.isDisabled = false;});
            (this.form.productType === 1 && this.form.triggerType === 0 && event === 1) && this.installTypeList.forEach(item => {
                item.isDisabled = item.value !== 0;
            });
            (this.form.productType === 1 && this.form.triggerType === 1 && event === 1) && this.installTypeList.forEach(item => {
                // item.isDisabled = item.value !== 0;
              item.isDisabled = false;
            });
            (this.form.productType === 1 && this.form.triggerType === 2 && event === 0) && this.installTypeList.forEach(item => {
                item.isDisabled = item.value !== 0;
            });
            (this.form.productType === 1 && this.form.triggerType === 3 && event === 0) && this.installTypeList.forEach(item => {item.isDisabled = false;});

            // 昵称
            (this.form.productType === 2 && this.form.triggerType === 0 && event === 0) && this.installTypeList.forEach(item => {item.isDisabled = false;});
            (this.form.productType === 2 && this.form.triggerType === 0 && event === 1) && this.installTypeList.forEach(item => {
                item.isDisabled = item.value !== 0;
            });
            (this.form.productType === 2 && this.form.triggerType === 3 && event === 0) && this.installTypeList.forEach(item => {item.isDisabled = false;});
            console.log(this.form.productType, this.form.triggerType, event, this.installTypeList)
        },

        handleFileChange() {
            this.progressStatus = null
            this.$refs.upload.submit();
        },

        // 计算整个文件的 MD5
        async calculateFileMD5(file) {
            return new Promise((resolve, reject) => {
                const chunkSize = 2 * 1024 * 1024; // 每个分片大小（2MB）
                const chunks = Math.ceil(file.size / chunkSize);
                const spark = new SparkMD5.ArrayBuffer();
                const fileReader = new FileReader();

                let currentChunk = 0;

                fileReader.onload = (e) => {
                    spark.append(e.target.result); // 将分片数据添加到 MD5 计算中
                    currentChunk++;

                    if (currentChunk < chunks) {
                        loadNextChunk();
                    } else {
                        resolve(spark.end()); // 返回整个文件的 MD5 值
                    }
                };

                fileReader.onerror = () => {
                    reject(new Error('文件读取失败'));
                };

                function loadNextChunk() {
                    const start = currentChunk * chunkSize;
                    const end = Math.min(start + chunkSize, file.size);
                    const chunk = file.slice(start, end);
                    fileReader.readAsArrayBuffer(chunk);
                }

                loadNextChunk();
            });
        },

        async customUpload() {

            if (!this.isUpload) return;

            // 初始化上传
            await this.initUpload();

            if (this.uploadId === null) {
                this.firmwareErr = '初始化上传失败！';
                this.delBtn();
                return;
            }

            console.log(this.totalChunks + '/' + this.uploadedChunks)
            // 并行上传所有分片
            const uploadPromises = [];
            for (let i = 0; i < this.totalChunks; i++) {
                if (!this.uploadedChunksList.includes(i)) {
                    uploadPromises.push(this.uploadChunk(i, 1));
                }
            }

            // 将数组分成每项长度为6的二维数组
            // const promiseGroups = [];
            // for (let i = 0; i < uploadPromises.length; i += 6) {
            //     promiseGroups.push(uploadPromises.slice(i, i + 6));
            // }

            // 以每6个分片为一轮请求，降低请求并发
            // for (let i = 0; i < promiseGroups.length; i++) {
            //     await Promise.all(promiseGroups[i]);
            // }

            // 等待所有分片上传完成
            await Promise.all(uploadPromises);

            if (this.uploadedChunks === this.totalChunks) {
                // 完成上传
                await this.completeUpload();
                this.progressStatus = "success";
            } else {
                this.progressStatus = "exception";
            }
            this.isShowProgress = false;
            this.fileLoading = false;
            this.progress = 0;
        },

        async beforeUpload(file) {
            console.log(file, file.size)
            this.isShowProgress = true;
            this.fileLoading = true;
            this.firmwareErr = "";
            if (file.size > (8*1024*1024*1024)) {
                this.firmwareErr = this.$i18n.t('ota.text92');
                this.fileLoading = false;
                this.isUpload = false;
                return false;
            }
            this.file = file;
            let chunkSize = 8 * 1024 * 1024;
            if (file.size <= chunkSize) {
                await this.uploadNoChunk();
                this.isUpload = false;
                return false;
            } else if ((file.size/chunkSize) <= 10) {
                console.log("单个分割文件大小为8M", file.size);
                this.chunkSize = chunkSize;
            } else if ((file.size/chunkSize) <= 100) {
                console.log("单个分割文件大小为20M", file.size);
                this.chunkSize = 20 * 1024 * 1024;
            } else {
                console.log("单个分割文件大小为40M", file.size);
                this.chunkSize = 40 * 1024 * 1024;
            }

            this.isUpload = true;
            this.totalChunks = Math.ceil(this.file.size / this.chunkSize);
            this.fileSize = this.file.size;
            this.progress = 0;
            this.uploadedChunks = 0;
            this.md5 = await this.calculateFileMD5(file);
            console.log("总md5", this.md5);
            return true;
        },

        async uploadNoChunk() {
            const formData = new FormData();
            formData.append('bucket', 'ota');
            formData.append('holdName', 'N');
            formData.append('file', this.file);

            await axios.post(this.$message.uploadImgUrl, formData, {
                timeout: 3600000,
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'accessToken': this.$token.getToken().accessToken,
                    'refreshToken': this.$token.getToken().refreshToken,
                    'language': this.language
                },
            })
                .then((response) => {
                    console.log(response.data);
                    this.form.filePath = response.data.result.fileList[0].filePath;
                    this.form.fileUrl = response.data.result.fileList[0].url;
                    this.progress = 100;
                    this.progressStatus = "success";
                    this.isShowProgress = false;
                    this.fileLoading = false;
                    this.progress = 0;
                })
                .catch((error) => {
                    this.firmwareErr = '完成上传失败'
                    this.progressStatus = "exception";
                    this.delBtn();
                    console.error('单文件上传失败:', error);
                });
        },

        async initUpload() {
            let vm = this;
            try {
                const formData = new FormData();
                formData.append('originalFilename', this.file.name);
                formData.append('fileSize', this.fileSize);
                formData.append('totalChunks', this.totalChunks);
                await axios.post(this.$message.uploadOtaInitUrl, formData,
                    {
                        timeout: 3600000,
                        headers: {
                            accessToken: vm.$token.getToken().accessToken,
                            refreshToken: vm.$token.getToken().refreshToken,
                            language: vm.language
                        }
                    })
                    .then((response) => {
                        console.log('初始化上传成功:', response.data);
                        if (response.data.success) {
                            vm.uploadId = response.data.result.uploadId;
                        } else {
                            vm.uploadId = null;
                            console.error('初始化上传失败:', response.data.resultMsg);
                        }
                    })
                    .catch((error) => {
                        vm.uploadId = null;
                        console.error('初始化上传失败1:', error);
                    });
            } catch (error) {
                vm.uploadId = null;
                console.error('初始化上传失败2:', error);
            }
        },

        async calculateBlobMD5(blob) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                const spark = new SparkMD5.ArrayBuffer();

                // 读取 Blob 为 ArrayBuffer
                reader.readAsArrayBuffer(blob);

                // 读取完成时触发
                reader.onload = (e) => {
                    spark.append(e.target.result); // 将数据添加到 MD5 计算中
                    resolve(spark.end()); // 返回 MD5 值
                };

                // 读取失败时触发
                reader.onerror = () => {
                    reject(new Error('读取 Blob 失败'));
                };
            });
        },

        // 上传单个分片
        async uploadChunk(chunkIndex, retryTimes) {
            const start = chunkIndex * this.chunkSize;
            const end = Math.min(start + this.chunkSize, this.file.size);
            const chunk = this.file.slice(start, end);
            const chunkMd5 = await this.calculateBlobMD5(chunk); //CryptoJS.MD5(chunk).toString(); // 计算分片MD5值
            const formData = new FormData();
            formData.append('file', chunk);
            formData.append('chunkIndex', chunkIndex);
            formData.append('totalChunks', this.totalChunks);
            formData.append('fileName', this.file.name);
            formData.append('uploadId', this.uploadId);
            formData.append('chunkMd5', chunkMd5);

            try {
                console.log('第' + chunkIndex + '片开始上传');
                console.log(start, end);
                console.log(chunk)
                console.log('md5:', chunkMd5);
                await axios.post(this.$message.uploadOtaChunkUrl, formData, {
                    timeout: 3600000,
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'accessToken': this.$token.getToken().accessToken,
                        'refreshToken': this.$token.getToken().refreshToken,
                        'language': this.language
                    },
                    // onUploadProgress: (progressEvent) => {
                    //     // 更新上传进度
                    //     // const chunkProgress = (progressEvent.loaded / progressEvent.total) * 100;
                    //     // this.progress = Math.round(((this.uploadedChunks + chunkProgress / 100) / this.totalChunks) * 100);
                    // },
                })
                    .then((response) => {
                        console.log('第' + chunkIndex + '片上传成功:', response.data);
                        this.uploadedChunks++;
                        this.uploadedChunksList.push(chunkIndex); // 记录已上传的分片

                        this.progress = Math.round((this.uploadedChunks / this.totalChunks) * 100);
                    })
                    .catch((error) => {
                        console.error('第' + chunkIndex + '片上传失败1:', error);
                        if (retryTimes < 5) {
                            console.log('第' + chunkIndex + '片重试第' + (retryTimes) + '次...');
                            this.uploadChunk(chunkIndex, retryTimes + 1);
                        } else {
                            console.error('第' + chunkIndex + '片上传失败2:', error);
                            // return;
                        }
                        // return;
                    });
            } catch (error) {
                console.error('分片上传失败2:', error);
            }
        },

        async completeUpload() {
            try {
                // 计算文件MD5值
                const formData = new FormData();
                formData.append('uploadId', this.uploadId);
                formData.append('bucket', "ota");
                formData.append('originalFilename', this.file.name);
                formData.append('fileSize', this.fileSize);
                formData.append('totalChunks', this.totalChunks);
                formData.append('md5', this.md5);
                await axios.post(this.$message.otaMergeUrl, formData,
                    {
                        timeout: 3600000,
                        headers: {
                            'accessToken': this.$token.getToken().accessToken,
                            'refreshToken': this.$token.getToken().refreshToken,
                            'language': this.language
                        }
                    })
                    .then((response) => {
                        if (response.data.success) {
                            console.log('合并文件成功:', response.data);
                            this.form.filePath = response.data.result.filePath;
                            this.form.fileUrl = response.data.result.url;
                        } else {
                            this.firmwareErr = '合并文件失败'
                            this.delBtn();
                            console.error('合并文件失败:', response.data.resultMsg);
                        }
                    })
                    .catch((error) => {
                        this.firmwareErr = '合并文件失败'
                        this.delBtn();
                        console.error('合并文件失败:', error);
                    });
            } catch (error) {
                this.firmwareErr = '完成上传失败'
                this.delBtn();
                console.error('完成上传失败:', error);
            }
        },

        handleOpen() {
            this.type = this.addOTADrawerType;
            this.$nextTick(() => {
              this.$refs.ruleForm.resetFields();
            })
        },

        closeDialog() {
            this.closeAddOTADrawer();
            this.$store.commit('maintain/SET_FIRMWARE_MSG', {});
            this.form = {
                otaFileCode: "",
                pid: "",
                firmwareModel: "",
                filePath: "",
                fileUrl: "",
                productType: 1,
                triggerType: "",
                downloadType: "",
                installType: "",
                reboot: "1",
                versionDescribe: "",
                versionType: 1
            }
            this.partitions = []
            this.partitionList = [
                {label: this.$i18n.t('ota.text84'), value: 1},
                {label: this.$i18n.t('ota.text85'), value: 2},
            ]
            this.file = {};
            this.firmwareErr = ""
            this.delBtn();
            this.$refs.ruleForm.resetFields();
        },

        submit() {
            if (!this.form.fileUrl) {
                this.firmwareErr = this.$i18n.t('ota.text93')
                return;
            }
            this.firmwareErr = ""
            let wipeArea = [];
            let wipeData = "false";
            let wipeMedia = "false";
            this.partitionList.forEach((item, index) => {
                if (index > 1) {
                    wipeArea.push({
                        k: item.value,
                        v: this.partitions.includes(item.value),
                        n: item.label
                    })
                }
            })
            if (this.partitions.length > 0) {
                this.partitions.forEach(item => {
                    if (item === 1) {
                        wipeData = "true";
                    } else if (item === 2) {
                        wipeMedia = "true";
                    }
                })
            }
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.loading = true;
                    if (this.type === 0) {
                        this.importFirmwareFile({
                            downloadType: this.form.downloadType,
                            filePath: this.form.filePath,
                            fileUrl: this.form.fileUrl,
                            firmwareModel: this.form.firmwareModel,
                            installType: this.form.installType,
                            pid: this.form.pid,
                            reboot: this.form.reboot === '1' ? 'true' : 'false',
                            productType: this.form.productType,
                            triggerType: this.form.triggerType,
                            versionDescribe: this.form.versionDescribe,
                            wipeArea: JSON.stringify(wipeArea),
                            wipeData,
                            wipeMedia,
                            versionType: this.form.versionType
                        }).then(() => {
                            this.$dialog.showMessage(this.$i18n.t('ota.text94'), this.$config.TOAST_SUCCESS);
                            this.$emit('getMsg');
                            this.closeDialog();
                        }, err => {
                            this.$dialog.showMessage(err.resultMsg, this.$config.TOAST_ERROR);
                        }).finally(() => {
                            this.loading = false
                        })
                    }
                    if (this.type === 1) {
                        this.modifyFirmwareFile({
                            downloadType: this.form.downloadType,
                            installType: this.form.installType,
                            otaFileCode: this.form.otaFileCode,
                            productType: this.form.productType,
                            reboot: this.form.reboot === '1' ? 'true' : 'false',
                            triggerType: this.form.triggerType,
                            versionDescribe: this.form.versionDescribe,
                            wipeArea: JSON.stringify(wipeArea),
                            wipeData,
                            wipeMedia,
                            versionType: this.form.versionType
                        }).then(() => {
                            this.$dialog.showMessage(this.$i18n.t('ota.text95'), this.$config.TOAST_SUCCESS);
                            this.$emit('getMsg');
                            this.closeDialog();
                        }, err => {
                            this.$dialog.showMessage(err.resultMsg, this.$config.TOAST_ERROR);
                        }).finally(() => {
                            this.loading = false
                        })
                    }
                }
            })
        }

    }

}
</script>

<style scoped>
::v-deep(.el-drawer__header) {
    font-weight: bold !important;
    text-align: left;
    color: black !important;
    padding: 10px 20px;
    margin-bottom: 0px;
    border-bottom: 1px solid #ebecf0;
}

::v-deep(.el-drawer__body) {
    padding: 0 20px;
}

::v-deep(.el-divider--horizontal) {
    margin: 0;
}

::v-deep(.el-breadcrumb__inner), ::v-deep(.el-breadcrumb__separator) {
    font-weight: bold !important;
}

::v-deep(.demo-drawer__footer) {
    position: fixed;
    right: 0;
    bottom: 0;
    z-index: 999;
    padding: 10px 20px;
    width: 500px;
    text-align: left;
    background-color: white;
    border-top: 1px solid #ebecf0;
}

.title {
    font-size: 14px;
    color: rgb(51, 51, 51);
    font-weight: bold;
    margin-top: 17px;
}

.upload_title {
    font-size: 12px;
    color: rgb(127, 127, 127);
    margin-top: -16px;
    line-height: 20px;
}

.ota_form {
    margin-bottom: 100px;
    margin-top: 14px;
}

.upload-msg {
    font-size: 20px;
    color: #3296FA;
    margin: 50px 10px;
    display: flex;
    flex-direction: row;
    text-align: center;
    justify-content: center;
}

::v-deep(.el-upload-dragger), ::v-deep(.el-upload) {
    width: 100%;
    height: 100%;
    padding-bottom: 20px;
}

.el-upload__text {
    line-height: 5px;
    margin-top: -10px;
}

.el-upload__subtitle {
    margin-bottom: 50px;
    font-size: 12px;
    line-height: 30px;
}

::v-deep(.file-upload .el-form-item__error){
    margin-top: 80px!important;
}
</style>
